"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _react = require("@emotion/react");

var _Dropdown = require("./Dropdown.styles");

var _util = require("../../util");

var icon = function icon(theme) {
  return /*#__PURE__*/(0, _react.css)("opacity:0;margin-left:", theme.spacing[5], ";color:", theme.color.dropdown.icon, ";svg{width:", (0, _util.rem)(16), ";height:", (0, _util.rem)(16), ";display:block;}" + (process.env.NODE_ENV === "production" ? "" : ";label:icon;"));
};

var base = function base(theme) {
  return /*#__PURE__*/(0, _react.css)(_Dropdown.styles.item(theme), ";transition:background-color 0.2s;cursor:pointer;&:hover{background-color:", theme.color.dropdownMenu.itemBgHover, ";color:", theme.color.dropdown.textHover, ";&>span:last-of-type{opacity:1;}}&:focus{outline:none;}" + (process.env.NODE_ENV === "production" ? "" : ";label:base;"));
}; // Negative hover effect


var negativeHover = function negativeHover(theme) {
  return /*#__PURE__*/(0, _react.css)("&>span:last-of-type{color:", theme.color.dropdown.negativeIcon, ";}&:hover{background-color:", theme.color.dropdownMenu.negativeItemBgHover, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:negativeHover;"));
}; // Add light-grey background and black-medium font


var highlight = function highlight(theme) {
  return /*#__PURE__*/(0, _react.css)("background-color:", theme.color.dropdownMenu.highlightBg, ";font-weight:", theme.fontWeight.medium, ";color:", theme.color.dropdown.textHover, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:highlight;"));
}; // Main styles


var styles = {
  base: base,
  negativeHover: negativeHover,
  highlight: highlight,
  icon: icon
};
exports.styles = styles;
//# sourceMappingURL=DropdownMenuItem.styles.js.map